
export const mutations = {
    SET_LIST: (state, layouts) => (state.list = layouts),
    SET_FLAT_LIST: (state, flat) => (state.flat = flat),
    SET_PLAN_IMG: (state, plan_img) => (state.plan_img = plan_img)
};
